// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from './application';

import NewCommentController from './new_comment_controller';
import ToggleElementController from './toggle_element_controller';
import SelectQuoteController from './select_quote_controller';
import TableFilterController from './table_filter_controller';
import EditDocumentsController from './edit_documents_controller';
import LoaderController from './loader_controller';
import SteppedModalController from './stepped_modal_controller';
import CalendarController from './calendar_controller';
import AlertController from './alert_controller';
import MoneyController from './money_controller';
import TooltipController from './tooltip_controller';
import CoverTabsController from './cover_tabs_controller';
import NestedModelController from './nested_model_controller.js';
import UserFormController from './user_form_controller.js';
import TableCheckboxesController from './table_checkboxes_controller.js';
import DailyFileController from './daily_file_controller.js';
import DuplicateAssetIdController from './duplicate_asset_id_controller.js';
import OpenModalController from './open_modal_controller.js';
import CopyToClipboard from './copy_to_clipboard_controller.js';
import EditQuotesController from './edit_quotes_controller.js';
import ConsentNoticeController from './consent_notice_controller.js';

application.register('new-comment', NewCommentController);
application.register('toggle-element', ToggleElementController);
application.register('select-quote', SelectQuoteController);
application.register('table-filter', TableFilterController);
application.register('edit-documents', EditDocumentsController);
application.register('loader', LoaderController);
application.register('stepped-modal', SteppedModalController);
application.register('calendar', CalendarController);
application.register('alert', AlertController);
application.register('money', MoneyController);
application.register('tooltip', TooltipController);
application.register('cover-tabs', CoverTabsController);
application.register('nested-model', NestedModelController);
application.register('user-form', UserFormController);
application.register('table-checkboxes', TableCheckboxesController);
application.register('daily-file', DailyFileController);
application.register('duplicate-asset-id', DuplicateAssetIdController);
application.register('open-modal', OpenModalController);
application.register('copy-to-clipboard', CopyToClipboard);
application.register('edit-quotes', EditQuotesController);
application.register('consent-notice', ConsentNoticeController);
